import { ControllerBase } from 'controllerBase';
import {renderizarComponentReact} from "../../components/renderizarOuRemoverComponentReact";
import {RelacionaObraEnderecoContainer} from "../../components/relaciona-obra-endereco/RelacionaObraEnderecoContainer";
import React from 'react';
declare var window:any
declare var orcamentoController:any
declare var EditarEnderecoOrcamentoController:any
declare var FreteOrcamentoController:any
declare var TipoEntregaOrcamentoController:any
const ko = require('knockout')

window.EnderecoOrcamentoController = ControllerBase.extend({
    name: "EnderecoOrcamentoController",

    framework: "knockout",

    ajax: function() {
        return {
            url: "/Orcamento/_EnderecoOrcamento",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                tipoOrcamento: this.orcamento.get("TipoOrcamento"),
            }
        };
    },

    antesBinding: function() {
        renderizarComponentReact(<RelacionaObraEnderecoContainer />, 'relaciona-obra-react', true)
        this.appendToModel({ name: "possuiEnderecoSelecionado", value: false });
    },

    aposBinding: function () {
        $('#AplicarEnderecoOrcamento').focus();
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    selecionarEndereco: function(model) {

        if (!this.quantidadeEnderecosSelecionados) {
            this.quantidadeEnderecosSelecionados = 0;
        }

        if (model.selecionado) {
            model.selecionado(!model.selecionado());

            this.quantidadeEnderecosSelecionados = this
                .quantidadeEnderecosSelecionados +
                (model.selecionado() ? 1 : -1);

        } else {
            this.appendToModel({ name: "selecionado", value: true });
        }

        this.model.possuiEnderecoSelecionado(this.quantidadeEnderecosSelecionados > 0);

    },

    incluir: function (e) {
        var self = this;
        this.editarEnderecoController = this.showView({
            region: {
                name: "editarEnderecoOrcamentoRegion",
                selector: "#editar-endereco-orcamento-region"
            },
            controller: {
                type: EditarEnderecoOrcamentoController,
                args: {
                    orcamento: this.orcamento,
                    enderecoEditadoCallback: $.proxy(this.enderecoEditado, this),
                    clienteNaoCadastrado: self.ClienteNaoCadastrado, // manut-163
                }
            }
        });

    },

    editar: function(model) {

        var m = ko.mapping.fromJS(ko.mapping.toJS(model));
		var self = this;
        m.editando = true;
        m.index = model.index ? model.index() : undefined;

        this.editarEnderecoController = this.showView({
            region: {
                name: "editarEnderecoOrcamentoRegion",
                selector: "#editar-endereco-orcamento-region"
            },
            model: m,
            controller: {
                type: EditarEnderecoOrcamentoController,
                args: {
                    orcamento: this.orcamento,
                    endereco: model,
                    editando: true,
                    enderecoEditadoCallback: $.proxy(this.enderecoEditado, this),
                    clienteNaoCadastrado: self.ClienteNaoCadastrado, // manut-163
                }
            }
        });


    },

    enderecoEditado: function(endereco) {

        if (!endereco.editando && endereco.Novo) {
            this.model.enderecos.push(endereco);

            var self = this;

            $.each(this.model.enderecos(),
                function(i) {

                    self.appendToModel({
                        name: "index",
                        value: i,
                        model: this
                    });

                });
        }

        global.ajax({
            url: "/Orcamento/SalvarEnderecoOrcamento",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                endereco: endereco
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

            }
        });


        this.editarEnderecoController.hide();
        this.show();

    },

    salvar: function() {

        var enderecos = this.toJS(this.model.enderecos());

        var self = this;

        global.ajax({
            url: "/Orcamento/SalvarEnderecoOrcamento",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                enderecos: enderecos
            }),
            success: function(data) {

                if (!data || data.HasErrors) {
                    return;
                }

                self.model.enderecos(ko.mapping.fromJS(data.Enderecos));
                self.orcamento.atualizar(data); //FNX-5478
                if (self.parent && self.parent.name === "OrcamentoController")
                    self.parent.renderizarViewEnderecos(); //FNX-5478

                if (!data.HasErrors) {
                    global.showSuccessMessage("Endereço(s) atualizado(s) com sucesso.");
                }
                $('html, body').animate({ scrollTop: $('html, body').offset().top }, 1000);
            }
        });

    },

    entregaAlterado: function(model, e) {

        if (!this.model || !this.model.enderecos || this.model.enderecos().length == 0) {
            return true;
        }

        $.each(this.model.enderecos(),
            function() {

                if (model.Entrega() && this.Entrega() && model.Codigo() != this.Codigo()) {
                    this.Entrega(false);
                }
            });

        return true;

    },

    cobrancaAlterado: function(model, e) {

        if (!this.model || !this.model.enderecos || this.model.enderecos().length == 0) {
            return true;
        }

        $.each(this.model.enderecos(),
            function() {

                if (model.Cobranca() && this.Cobranca() && model.Codigo() != this.Codigo()) {
                    this.Cobranca(false);
                }
            });

        return true;

    },

    faturamentoAlterado: function(model, e) {

        if (!this.model || !this.model.enderecos || this.model.enderecos().length == 0) {
            return true;
        }

        $.each(this.model.enderecos(),
            function() {

                if (model.Faturamento() && this.Faturamento() && model.Codigo() != this.Codigo()) {
                    this.Faturamento(false);
                }
            });

        return true;

    }


});
